import * as React from "react";
import styles = require("./style.less");

interface InputLabelProps {
    label: string | JSX.Element;
}

const InputLabel: React.FC<InputLabelProps> = (props) => {
    return <div className={styles.label}>
        {props.label}
    </div>;
};

export default InputLabel;
